import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'

import { BehaviorSubject, filter, takeUntil, tap, withLatestFrom } from 'rxjs'

import { APP_DEFAULT_LANGUAGE } from '~/core/constants'
import { DestroyDirective } from '~/core/directives'
import {
  DEFAULT_CNT_EST_ORDER,
  DEFAULT_CNT_EST_SORT_BY,
  PerformanceFacade,
  UiFacade,
} from '~/core/features'
import { EPerformanceSummaryFlag, IPerformanceCntEst } from '~/core/models'
import { AsyncBlockComponent } from '~/ui/async-block'

import { WinRatesByCntEstComponent } from './components'

@Component({
  selector: 'app-analyst-coverage-tab',
  templateUrl: './analyst-coverage-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [AsyncPipe, AsyncBlockComponent, WinRatesByCntEstComponent],
})
export class AnalystCoverageTabComponent implements OnInit {
  private readonly destroy$ = inject(DestroyDirective).destroy$

  readonly performanceFacade = inject(PerformanceFacade)
  readonly uiFacade = inject(UiFacade)

  DEFAULT_CNT_EST_ORDER = DEFAULT_CNT_EST_ORDER
  DEFAULT_CNT_EST_SORT_BY = DEFAULT_CNT_EST_SORT_BY
  APP_DEFAULT_LANGUAGE = APP_DEFAULT_LANGUAGE

  readonly data$ = new BehaviorSubject<IPerformanceCntEst[]>([])
  readonly total$ = new BehaviorSubject<IPerformanceCntEst | null>(null)

  constructor() {}

  ngOnInit(): void {
    this.performanceFacade.quarter$
      .pipe(
        filter(quarter => Boolean(quarter)),
        withLatestFrom(this.performanceFacade.cntEstSortBy$, this.performanceFacade.cntEstOrder$),
        tap(([, sortBy, order]) =>
          this.performanceFacade.getPerformanceCntEst(
            sortBy || DEFAULT_CNT_EST_SORT_BY,
            order || DEFAULT_CNT_EST_ORDER
          )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe()

    this.performanceFacade.cntEstData$
      .pipe(
        tap(data => {
          this.data$.next(
            (data || []).filter(item => item.summaryFlag !== EPerformanceSummaryFlag.SUMMARY_COLUMN)
          )
          const total: IPerformanceCntEst | null =
            data?.find(item => item.summaryFlag === EPerformanceSummaryFlag.SUMMARY_COLUMN) || null

          this.total$.next(total)
        }),
        takeUntil(this.destroy$)
      )
      .subscribe()
  }

  changeSort(sortBy: string, order: 'asc' | 'desc' | ''): void {
    this.performanceFacade.getPerformanceCntEst(sortBy, order)
  }
}
